import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonList,
  IonListHeader,
  IonLoading,
  IonMenuButton,
  IonModal,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonRow,
  IonSkeletonText,
  IonSpinner,
  IonTitle,
  IonToolbar,
  RefresherEventDetail,
  useIonLoading,
  useIonViewDidEnter,
} from "@ionic/react";
import { useHistory, useLocation, useParams } from "react-router";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import Navbar from "../../../components/WebApp/Navbar/Navbar";
import PubSub from "../../../lib/PubSub";
import ReactPlayer from "react-player";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  arrowForward,
  calendar,
  calendarClearOutline,
  cashOutline,
  checkmarkCircleOutline,
  chevronForward,
  closeOutline,
  copyOutline,
  create,
  createOutline,
  ellipsisVertical,
  pause,
  pencil,
  pencilSharp,
  play,
  pricetag,
  pricetags,
  recording,
  settings,
  share,
  shareOutline,
  stop,
  videocam,
} from "ionicons/icons";

import consultImage from "../../../assets/img/brand/consultation.jpg";
import referralImage from "../../../assets/img/brand/give20get20.jpg";
import StorageUtils from "../../../lib/StorageUtils";
import API from "../../../lib/API";
import StringUtils from "../../../lib/StringUtils";
import moment from "moment";
import Constants from "../../../lib/Constants";
import Event from "../../../lib/Event";
import InlineSchedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineSchedulingModal";
import InlineReschedulingModal from "../../../components/Scheduler/SchedulingCalendar/InlineReschedulingModal";
import AppointmentInformation from "../../../components/Scheduler/AppointmentInformation/AppointmentInformation";
import DateUtils from "../../../lib/DateUtils";
import UpcomingOrderCard from "../../../components/AccountManagement/UpcomingOrderCard/UpcomingOrderCard";
import ReviewOrderCard from "../../../components/AccountManagement/ReviewOrderCard/ReviewOrderCard";
import _, { object } from "underscore";
import MealDetailContent from "../../../components/MealDetailContent";
import SEOHeaders from "../../../components/SEOHeaders";
import { Capacitor } from "@capacitor/core";
import { ScreenOrientation } from "@capacitor/screen-orientation";

import "./TestimonialPage.css";
import { stat } from "fs";
import { clear } from "console";
import { start } from "repl";
import VerticalVideoRecorder from "../../../components/VerticalVideoRecorder/VerticalVideoRecorder";
import { Device } from "@capacitor/device";

const TestimonialPage: React.FC<{
  nativeMode?: boolean;
  showBackButton?: boolean;
}> = ({ nativeMode = false, showBackButton = false }) => {
  const [user, setUser] = useState<any>(null);
  const [referralProgram, setReferralProgram] = useState<any>({
    name: "Give $20, Get $20",
    value: 2000,
  });
  const history = useHistory();

  // Detect iOS Safari for fallback
  const isIosSafari = /iP(hone|ad|od).*Version\/.*Safari/.test(
    navigator.userAgent,
  );
  const isAndroidMobile = /Android.*Mobile/.test(navigator.userAgent);
  const fallbackFileMode = isIosSafari || isAndroidMobile;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [customerID, setCustomerID] = useState("");
  const [leadID, setLeadID] = useState("");
  const [loading, setLoading] = useState(true);
  const [testimonial, setTestimonial] = useState<any>(null);
  const [instagramHandle, setInstagramHandle] = useState("");
  const [sessionID, setSessionID] = useState("");
  const location = useLocation();
  const routeParams: any = useParams();
  const [store, setStore] = useState<any>(null);
  const promptVideoRef = useRef<HTMLVideoElement>(null);
  const [playPrompt, setPlayPrompt] = useState(false);
  const [playPreview, setPlayPreview] = useState(false);
  const [mutePrompt, setMutePrompt] = useState(true);
  const [prompt, setPrompt] = useState<any>(null);
  const [promptIndex, setPromptIndex] = useState(0);
  const [recordPrompt, setRecordPrompt] = useState(false);
  const [promptVideoDuration, setPromptVideoDuration] = useState(0);
  const [promptVideoElapsed, setPromptVideoElapsed] = useState(0);
  const [previewVideoDuration, setPreviewVideoDuration] = useState(0);
  const [previewVideoElapsed, setPreviewVideoElapsed] = useState(0);
  const [countdown, setCountdown] = useState(0);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [previewRecording, setPreviewRecording] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const [copied, setCopied] = useState(false);
  const [mode, setMode] = useState("intro");
  const previewRef: any = useRef();

  const [prompts, setPrompts] = useState<any>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);

  // Trigger file input only on user tap (not on mount)
  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  // Handle video file selection
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }

    console.log(file);

    const url = URL.createObjectURL(file);
    const vid = document.createElement("video");
    vid.preload = "metadata";
    vid.onloadedmetadata = () => {
      const duration = vid.duration;
      //URL.revokeObjectURL(vid.src);

      console.log("FILE DURATION", duration);

      // same as onRecordingComplete callback from VideoRecorder:
      setPreviewRecording(true);
      setRecordPrompt(true);
      setPlayPreview(true);
      setBlobURL(url);
      setPreviewVideoDuration(duration);

      submitRecording(prompt, url, duration);
    };
    vid.src = url;
  };

  const loadTestimonialTemplate = async (storyID: string) => {
    setLoading(true);

    API.getTestimonialTemplate(storyID).then(
      (data: any) => {
        let template = data?.data?.data?.template;

        setLoading(false);

        if (data?.data?.data?.template?.prompts?.length) {
          console.log("PROMPTS", data?.data?.data?.template?.prompts);

          setPrompts(data?.data?.data?.template?.prompts);

          setTimeout(() => {
            let promptID = new URLSearchParams(window.location.search).get(
              "pid",
            );

            if (
              promptID &&
              _.findWhere(data?.data?.data?.template?.prompts, {
                _id: promptID,
              })
            ) {
              setPrompt(
                _.findWhere(data?.data?.data?.template?.prompts, {
                  _id: promptID,
                }),
              );
              setPromptIndex(
                _.findIndex(data?.data?.data?.template?.prompts, {
                  _id: promptID,
                }),
              );
              setMode("prompt");
            }
          }, 0);
        } else {
          template.acceptingResponses = false;
        }

        setTestimonial(template);
      },
      (e) => {
        // toast here for cannot find testimonial

        setTestimonial(null);
        setLoading(false);
      },
    );
  };

  const loadPage = async () => {
    if (Capacitor.isNativePlatform()) {
      API.setEnvironment(API.ENV_PRODUCTION);
    } else if (window?.location?.href?.includes("localhost")) {
      API.setEnvironment(API.ENV_DEV);
    } else {
      API.setEnvironment(API.ENV_PRODUCTION);
    }

    //const supportedMediaConstraints = navigator.mediaDevices.getSupportedConstraints();
    //console.log("SUPPORTED MEDIA CONSTRAINTS", supportedMediaConstraints);

    // If not sessionid url param is set, set one with a UUID

    let sessionID = new URLSearchParams(window.location.search).get("sid");
    let email = new URLSearchParams(window.location.search).get("e");
    let name = new URLSearchParams(window.location.search).get("n");
    let customerID = new URLSearchParams(window.location.search).get("cid");
    let leadID = new URLSearchParams(window.location.search).get("lid");

    if (!sessionID) {
      sessionID = StringUtils.uuid();

      const newURL = new URL(window.location.href);
      newURL.searchParams.set("sid", sessionID);
      window.history.replaceState({}, "", newURL);
    }

    if (email) {
      setEmail(email);
    }

    if (name) {
      setName(name);
    }

    if (customerID) {
      setCustomerID(customerID);
    }

    if (leadID) {
      setLeadID(leadID);
    }

    setSessionID(sessionID);

    console.log("LOAD PAGE", routeParams?.storyID);

    loadTestimonialTemplate(routeParams?.storyID);
  };

  const getPromptByID = (id: string) => {
    const prompt = prompts.find((prompt: any) => prompt._id == id);

    if (prompt) {
      return prompt;
    }

    return null;
  };

  const getPromptByIndex = (index: number) => {
    if (index < prompts.length) {
      return prompts[index];
    }

    return null;
  };

  const hasNextPrompt = (index: number) => {
    if (index + 1 < prompts.length) {
      return true;
    }

    return false;
  };

  const getNextPrompt = (index: number) => {
    console.log("GET NEXT PROMPT", prompts[index + 1]);

    if (index + 1 < prompts.length) {
      return prompts[index + 1];
    }

    return null;
  };

  const getPreviousPrompt = (index: number) => {
    if (index - 1 >= 0) {
      return prompts[index - 1];
    }

    return null;
  };

  const getPromptIndex = (id: string) => {
    const prompt = prompts.find((prompt: any) => prompt._id == id);

    if (prompt) {
      return prompts.indexOf(prompt);
    }

    return -1;
  };

  const loadNextPrompt = () => {
    if (mode == "intro") {
      setMode("prompt");

      const nextPrompt = getPromptByIndex(0);

      if (nextPrompt) {
        setPrompt(nextPrompt);
        setPromptIndex(0);
        setPlayPrompt(true);

        // set PID here
        const newURL = new URL(window.location.href);
        newURL.searchParams.set("pid", nextPrompt?._id);
        window.history.replaceState({}, "", newURL);

        return;
      }
    }

    const nextPrompt = getNextPrompt(promptIndex);

    if (nextPrompt) {
      setPrompt(nextPrompt);
      setPromptIndex(promptIndex + 1);
      setPlayPrompt(true);
      setRecordPrompt(false);
      setPreviewRecording(false);
      setBlobURL("");
      setPlayPreview(false);
      setPreviewVideoElapsed(0);
      setPromptVideoElapsed(0);
      setCountdown(0);

      // set PID here
      const newURL = new URL(window.location.href);
      newURL.searchParams.set("pid", nextPrompt?._id);
      window.history.replaceState({}, "", newURL);
    } else if (mode == "prompt") {
      setMode("contact");
    } else if (mode == "contact") {
      setMode("thankyou");
    }
  };

  const submitTestimonial = () => {
    console.log("SUBMIT TESTIMONIAL");

    setSubmitting(true);

    API.submitTestimonial(testimonial?._id, {
      sessionID: sessionID,
      name: name,
      email: email,
      instagramHandle: instagramHandle,
      customerID: customerID ? customerID : null,
      leadID: leadID ? leadID : null,
    })
      .then(
        (data: any) => {
          console.log("SUBMIT TESTIMONIAL RESPONSE", data?.data?.data);

          loadNextPrompt();
        },
        (e) => {
          //TODO: error handling here
        },
      )
      .finally(() => {
        setSubmitting(false);
      });
  };

  const submitRecording = async (
    prompt: any,
    blobURL: any,
    duration: number,
  ) => {
    //console.log("SUBMITTING RECORDING", prompt, blobURL);

    setSubmitting(true);

    // Get blob to use in FormData
    const response = await fetch(blobURL);
    const blob = await response.blob();
    console.log("BLOB", blob);

    const file = new File(
      [blob],
      `video_${prompt?._id}_${StringUtils.uuid()}.webm`,
      { type: "video/webm" },
    );

    const formData = new FormData();
    formData.append(
      "file",
      blob,
      `testimonial_${testimonial?._id}_${sessionID}_${
        prompt?._id
      }_${StringUtils.uuid()}.webm`,
    );

    console.log(file.size);
    console.log(file.type);

    API.uploadPrivateFile(formData).then(
      (data) => {
        console.log(data?.data?.data);

        let testimonialResponse = {
          testimonialID: testimonial?._id,
          sessionID: sessionID,
          promptID: prompt?._id,
          video: data?.data?.data,
          duration: duration,
        };

        API.submitTestimonialRecording(testimonial?._id, testimonialResponse)
          .then(
            (data: any) => {
              console.log("SUBMIT TESTIMONIAL RESPONSE", data?.data?.data);

              loadNextPrompt();
            },
            (e) => {},
          )
          .finally(() => {
            setSubmitting(false);
          });
      },
      (e) => {
        // TODO: error handling here
        setSubmitting(false);
      },
    );
  };

  useEffect(() => {
    loadPage();
  }, [routeParams?.storyID]);

  useIonViewDidEnter(() => {
    console.log("ION VIEW DID ENTER");

    PubSub.publish("mobileScreenChange");
  }, []);

  const VideoPreview = ({
    stream,
    innerRef,
  }: {
    stream: MediaStream | null;
    innerRef: any;
  }) => {
    useEffect(() => {
      if (innerRef.current && stream) {
        innerRef.current.srcObject = stream;
      }
    }, [stream]);

    if (!stream) {
      return null;
    }
    return (
      <video
        id="preview"
        ref={innerRef}
        style={{
          minHeight: "100%",
          height: "100%",
          width: "auto",
          aspectRatio: "9/16",
        }}
        autoPlay
        playsInline
      />
    );
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <div
        className={`flex rounded-lg justify-center items-center sm:p-12 ${
          loading || mode == "intro" || mode == "contact" || mode == "thankyou"
            ? "h-full"
            : "h-screen"
        } w-full md:min-h-[700px]`}
      >
        <div
          style={{
            height: "100%",
            position: "relative",
            aspectRatio: "9/16",
          }}
          className="overflow-hidden sm:rounded-xl sm:shadow-2xl sm:border-[1px] sm:border-gray-100"
        >
          {loading ? (
            <>
              <div className="h-full" style={{ overflowY: "auto" }}>
                <div className="p-[2rem]" style={{ position: "relative" }}>
                  <div className="flex justify-center mb-12 mt-12">
                    <img src={plnSymbol} className="w-[5rem] h-[5rem]" />
                  </div>
                  <h1 className="font-[500] text-3xl text-gray-900 text-center">
                    <IonSkeletonText
                      style={{ height: 72 }}
                      className="rounded"
                      animated={true}
                    ></IonSkeletonText>
                  </h1>
                  <p className="text-gray-900 mt-4 text-center text-lg">
                    <IonSkeletonText
                      style={{ height: 84 }}
                      className="rounded"
                      animated={true}
                    ></IonSkeletonText>
                  </p>
                  <h1 className="font-[500] text-2xl mt-5 text-gray-900 text-center">
                    <IonSkeletonText
                      style={{ height: 32 }}
                      className="rounded"
                      animated={true}
                    ></IonSkeletonText>
                  </h1>
                  <p className="text-gray-900 mt-3 text-center text-lg">
                    <IonSkeletonText
                      style={{ height: 112 }}
                      className="rounded"
                      animated={true}
                    ></IonSkeletonText>
                  </p>
                  <div className="mt-5 mb-6">
                    <IonSkeletonText
                      style={{ height: 48 }}
                      className="rounded"
                      animated={true}
                    ></IonSkeletonText>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {testimonial?.acceptingResponses ? (
                <>
                  {mode == "intro" ? (
                    <>
                      <div className="h-full" style={{ overflowY: "auto" }}>
                        <div
                          className="p-[2rem]"
                          style={{ position: "relative" }}
                        >
                          <div className="flex justify-center mb-12 mt-12">
                            <img
                              src={plnSymbol}
                              className="w-[5rem] h-[5rem]"
                            />
                          </div>
                          <h1 className="font-[500] text-2xl sm:text-3xl text-gray-900 text-center">
                            {testimonial?.title}
                          </h1>
                          <p className="text-gray-900 mt-4 text-center text-lg">
                            {testimonial?.summary}
                          </p>
                          <h1 className="font-[500] text-2xl mt-[2rem] text-gray-900 text-center">
                            How It Works
                          </h1>
                          <p className="text-gray-900 mt-3 text-center text-lg">
                            {testimonial?.howItWorks}
                          </p>
                          <div className="mt-5 mb-6">
                            <button
                              className="bg-orange-500 flex gap-x-2 items-center justify-center text-white w-full py-[0.75rem] shadow-lg border-[1px] border-orange-600 font-bold rounded-lg"
                              onClick={() => {
                                setMode("prompt");
                                loadNextPrompt();
                              }}
                            >
                              <span>{testimonial?.ctaButtonText}</span>
                              <span
                                style={{
                                  lineHeight: 1,
                                  position: "relative",
                                  top: 2,
                                }}
                              >
                                <IonIcon
                                  style={{ fontSize: 20 }}
                                  icon={arrowForward}
                                />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {mode == "prompt" ? (
                    <>
                      {countdown > 0 ? (
                        <div className="z-[1] absolute left-[0px] top-[0px] flex justify-center text-white bg-transparent items-center h-full w-full">
                          <h1 className="text-5xl font-bold">{countdown}</h1>
                        </div>
                      ) : null}
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept="video/*"
                        capture="user"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                      {recordPrompt ? (
                        <>
                          {previewRecording ? (
                            <>
                              <div
                                className="h-full"
                                style={{ position: "relative" }}
                              >
                                <div
                                  className="flex justify-center bg-gray-900"
                                  style={{
                                    height: "100%",
                                    width: "auto",
                                    aspectRatio: "9/16",
                                  }}
                                >
                                  <ReactPlayer
                                    fileConfig={{
                                      attributes: { playsinline: true },
                                    }}
                                    volume={1}
                                    muted={false}
                                    url={blobURL}
                                    ref={previewRef}
                                    controls={false}
                                    playsinline={true}
                                    onProgress={(progress: any) => {
                                      /*console.log(
                              "Preview PROGRESS",
                              progress,
                              progress.playedSeconds
                            );*/

                                      setPreviewVideoElapsed(
                                        progress.playedSeconds,
                                      );
                                    }}
                                    onEnded={() => {
                                      // console.log("ENDED");

                                      setPlayPreview(false);
                                    }}
                                    playing={playPreview}
                                    className="testimonial-prompt-player"
                                    height={"100%"}
                                    width={"100%"}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>

                                <div
                                  style={{
                                    width: "100%",
                                    zIndex: 1,
                                  }}
                                  className="p-[2rem] fixed md:absolute left-0 bottom-[2rem]"
                                >
                                  <div className="bg-white flex rounded mb-4 h-[24px]">
                                    <button
                                      className="bg-orange-500 px-2 rounded text-white "
                                      style={{
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                      }}
                                      onClick={() => {
                                        if (
                                          playPreview == false &&
                                          previewVideoElapsed ==
                                            previewVideoDuration
                                        ) {
                                          setPreviewVideoElapsed(0);
                                        }

                                        setPlayPreview(!playPreview);
                                      }}
                                    >
                                      {playPrompt ? (
                                        <IonIcon
                                          style={{
                                            lineHeight: 1,
                                            position: "relative",
                                            top: 2,
                                          }}
                                          icon={pause}
                                        ></IonIcon>
                                      ) : (
                                        <IonIcon
                                          style={{
                                            lineHeight: 1,
                                            position: "relative",
                                            top: 2,
                                          }}
                                          icon={play}
                                        ></IonIcon>
                                      )}
                                    </button>
                                    <div
                                      style={{
                                        width: `calc(${
                                          (previewVideoElapsed /
                                            previewVideoDuration) *
                                          100
                                        }% - 32px)`,
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0,
                                      }}
                                      className="d-inline-block bg-orange-200 rounded h-[24px]"
                                    ></div>
                                  </div>
                                  <div className="flex gap-x-3">
                                    <button
                                      className={`${
                                        submitting
                                          ? "bg-gray-100 text-gray-400"
                                          : "bg-orange-500 text-white"
                                      } flex justify-center items-center gap-x-3 w-full py-[0.75rem] shadow-lg border-[1px] border-orange-600 font-bold rounded-lg`}
                                      onClick={() => {
                                        setTimeout(() => {
                                          setBlobURL("");

                                          if (fallbackFileMode) {
                                            setRecordPrompt(false);
                                            setPlayPreview(false);
                                            setPreviewRecording(false);
                                          } else {
                                            setPreviewRecording(false);
                                          }
                                        }, 0);
                                      }}
                                      disabled={submitting}
                                    >
                                      Record Again
                                    </button>
                                    <button
                                      className={`${
                                        submitting
                                          ? "bg-gray-100 text-gray-400"
                                          : "bg-orange-500 text-white"
                                      } flex justify-center items-center gap-x-3 h-[48px]  w-full py-[0.75rem] shadow-lg border-[1px] border-orange-600 font-bold rounded-lg`}
                                      onClick={() => {
                                        submitRecording(
                                          prompt,
                                          blobURL,
                                          previewVideoDuration,
                                        );
                                      }}
                                      disabled={submitting}
                                    >
                                      {submitting ? (
                                        <IonSpinner name="dots" />
                                      ) : (
                                        "Continue"
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <VerticalVideoRecorder
                                maxDuration={prompt?.maxDuration * 1000}
                                onRecordingComplete={(
                                  blob: Blob,
                                  blobUrl: string,
                                  duration: number,
                                ) => {
                                  console.log("BLOB URL", blobUrl);

                                  setPreviewRecording(true);
                                  setPlayPreview(true);
                                  setBlobURL(blobUrl);
                                  setPreviewVideoDuration(duration);
                                }}
                                onClose={() => {
                                  setRecordPrompt(false);
                                }}
                              ></VerticalVideoRecorder>
                            </>
                          )}
                        </>
                      ) : (
                        <div
                          className="flex justify-center bg-gray-900"
                          style={{
                            position: "relative",
                            height: "100%",

                            width: "100%",
                          }}
                        >
                          <div
                            className="text-white text-center px-[2rem] pb-[3rem] pt-[2rem]"
                            style={{
                              position: "absolute",
                              width: "100%",
                              top: 0,
                              left: 0,
                              background:
                                "linear-gradient(180deg,rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0.7) 50%, rgba(0, 0, 0, 0) 100%)",
                            }}
                          >
                            <div className="rounded border-[1px] border-white d-inline-block mx-auto mb-3 px-[0.5rem]">
                              Question {promptIndex + 1} of {prompts.length}
                            </div>
                            <h1
                              className="font-[500] text-2xl"
                              style={{ lineHeight: 1.35 }}
                            >
                              {prompt?.prompt}
                            </h1>
                          </div>
                          <div
                            onClick={() => {
                              setPlayPrompt(!playPrompt);
                            }}
                            className="flex justify-center items-center"
                          >
                            <ReactPlayer
                              url={prompt?.video?.url ? prompt?.video?.url : ""}
                              playsinline={true}
                              playing={playPrompt}
                              onReady={() => {
                                console.log("READY");
                              }}
                              className="testimonial-prompt-player"
                              onProgress={(progress: any) => {
                                //console.log("PROGRESS", progress);

                                setPromptVideoElapsed(progress.playedSeconds);
                              }}
                              onDuration={(duration: any) => {
                                //console.log("DURATION", duration);

                                setPromptVideoDuration(duration);
                              }}
                              onEnded={() => {
                                //console.log("ENDED");

                                setPlayPrompt(false);
                              }}
                              height={"100%"}
                              width={"100%"}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>

                          <div
                            style={{
                              width: "100%",
                              zIndex: 1,
                            }}
                            className="p-[2rem] fixed sm:absolute left-0 bottom-[1rem]"
                          >
                            <div className="bg-white flex rounded mb-4 h-[24px]">
                              <button
                                className="bg-orange-500 px-2 rounded text-white "
                                style={{
                                  borderTopRightRadius: 0,
                                  borderBottomRightRadius: 0,
                                }}
                                onClick={() => {
                                  if (
                                    playPrompt == false &&
                                    promptVideoElapsed == promptVideoDuration
                                  ) {
                                    setPromptVideoElapsed(0);
                                  }

                                  setPlayPrompt(!playPrompt);
                                }}
                              >
                                {playPrompt ? (
                                  <IonIcon
                                    style={{
                                      lineHeight: 1,
                                      position: "relative",
                                      top: 2,
                                    }}
                                    icon={pause}
                                  ></IonIcon>
                                ) : (
                                  <IonIcon
                                    style={{
                                      lineHeight: 1,
                                      position: "relative",
                                      top: 2,
                                    }}
                                    icon={play}
                                  ></IonIcon>
                                )}
                              </button>
                              <div
                                style={{
                                  width: `calc(${
                                    (promptVideoElapsed / promptVideoDuration) *
                                    100
                                  }% - 32px)`,
                                  borderTopLeftRadius: 0,
                                  borderBottomLeftRadius: 0,
                                }}
                                className="d-inline-block bg-orange-200 rounded h-[24px]"
                              ></div>
                            </div>
                            <div
                              className="bg-orange-500 flex flex-col items-center text-white w-full py-[0.75rem] shadow-lg border-[1px] border-orange-600 font-bold rounded-lg"
                              onClick={() => {
                                if (
                                  fallbackFileMode ||
                                  window?.innerWidth < 768
                                ) {
                                  handleFileClick();
                                } else {
                                  setRecordPrompt(true);
                                  setPlayPrompt(false);
                                  setPromptVideoElapsed(0);
                                }
                              }}
                            >
                              <div className="flex justify-center items-center gap-x-3">
                                <IonIcon
                                  style={{
                                    fontSize: 20,
                                    position: "relative",

                                    lineHeight: 1,
                                  }}
                                  icon={videocam}
                                ></IonIcon>
                                Record Your Response
                              </div>
                              {prompt?.maxDuration ? (
                                <div className="text-xs text-white bg-orange-500 px-2 rounded-full">
                                  Share up to{" "}
                                  {moment()
                                    .add(prompt?.maxDuration, "seconds")
                                    .fromNow(true)}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  ) : null}

                  {mode == "contact" ? (
                    <>
                      <div className="h-full" style={{ overflowY: "auto" }}>
                        <div
                          className="p-[2rem]"
                          style={{ position: "relative" }}
                        >
                          <div className="flex justify-center mb-12 mt-12">
                            <img
                              src={plnSymbol}
                              className="w-[5rem] h-[5rem]"
                            />
                          </div>
                          <h1 className="font-[500] text-3xl text-gray-900 text-center">
                            Thank you for sharing!
                          </h1>
                          <p className="text-gray-900 mt-4 text-center text-lg">
                            We appreciate you taking the time to share your
                            story with us. Before we wrap up, we just need a few
                            more details.
                          </p>
                          <h1 className="font-[500] text-2xl mt-5 text-gray-900 text-center">
                            Enter Your Information Below
                          </h1>
                          <p className="text-gray-900 mt-3 text-center text-lg">
                            Please share your name and email below so we can
                            follow up with you!
                          </p>
                          <div className="mt-5 mb-6">
                            <div className="mb-4">
                              <div className="relative">
                                <label
                                  htmlFor="name"
                                  className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500"
                                >
                                  Name
                                  <span className="text-red-600 ml-[2px]">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="text"
                                  name="name"
                                  autoComplete="name"
                                  value={name}
                                  className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                                  placeholder="Sally Smith"
                                  onChange={(event) => {
                                    setName(event.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="mb-4">
                              <div className="relative">
                                <label
                                  htmlFor="name"
                                  className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500"
                                >
                                  Email
                                  <span className="text-red-600 ml-[2px]">
                                    *
                                  </span>
                                </label>
                                <input
                                  type="email"
                                  name="email"
                                  autoComplete="email"
                                  value={email}
                                  className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                                  placeholder="hello@projectleannation.com"
                                  onChange={(event) => {
                                    setEmail(
                                      event.target.value?.toLowerCase()?.trim(),
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <div className="mb-4">
                              <div className="relative">
                                <label
                                  htmlFor="name"
                                  className="absolute rounded-sm -top-[9px] left-2 inline-block bg-white px-1.5 text-[13px] font-medium text-gray-800 focus:text-orange-500"
                                >
                                  Instagram Handle
                                </label>
                                <input
                                  type="text"
                                  name="instagramHandle"
                                  autoComplete="instagramHandle"
                                  value={instagramHandle}
                                  className="block w-full text-base sm:text-lg rounded outline-0 border border-gray-100 px-3 py-[0.7rem] text-gray-900 ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 transition-all focus:ring-2 focus:ring-inset focus:ring-orange-500 sm:leading-6"
                                  placeholder="@projectleannation"
                                  onChange={(event) => {
                                    setInstagramHandle(
                                      event.target.value?.toLowerCase()?.trim(),
                                    );
                                  }}
                                />
                              </div>
                            </div>
                            <button
                              className={`${
                                submitting || !email || !name
                                  ? "bg-gray-100 text-gray-400"
                                  : "bg-orange-500  border-orange-600 text-white "
                              } flex gap-x-2 items-center h-[48px] justify-center w-full py-[0.75rem] shadow-lg border-[1px] font-bold rounded-lg`}
                              onClick={() => {
                                submitTestimonial();
                              }}
                              disabled={submitting || !email || !name}
                            >
                              {submitting ? (
                                <IonSpinner name="dots" />
                              ) : (
                                <>
                                  <span>Submit</span>
                                  <span
                                    style={{
                                      lineHeight: 1,
                                      position: "relative",
                                      top: 2,
                                    }}
                                  >
                                    <IonIcon
                                      style={{ fontSize: 20 }}
                                      icon={arrowForward}
                                    />
                                  </span>
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                  {mode == "thankyou" ? (
                    <>
                      <div className="h-full" style={{ overflowY: "auto" }}>
                        <div
                          className="p-[2rem]"
                          style={{ position: "relative" }}
                        >
                          <div className="flex justify-center mb-12 mt-12">
                            <img
                              src={plnSymbol}
                              className="w-[5rem] h-[5rem]"
                            />
                          </div>
                          <h1 className="font-[500] text-3xl text-gray-900 text-center">
                            {testimonial?.thankYouTitle}
                          </h1>
                          <p className="text-gray-900 mt-4 text-center text-lg">
                            {testimonial?.thankYouSummary}
                          </p>

                          <div className="mt-5 mb-6">
                            <button
                              className="bg-orange-500 flex gap-x-2 items-center justify-center text-white w-full py-[0.75rem] shadow-lg border-[1px] border-orange-600 font-bold rounded-lg"
                              onClick={() => {
                                if (Capacitor.isNativePlatform()) {
                                  history.push("/manage");

                                  return;
                                }

                                window.open(
                                  "https://projectleannation.com",
                                  "_self",
                                );
                              }}
                            >
                              <span>Return Home</span>
                              <span
                                style={{
                                  lineHeight: 1,
                                  position: "relative",
                                  top: 2,
                                }}
                              >
                                <IonIcon
                                  style={{ fontSize: 20 }}
                                  icon={arrowForward}
                                />
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </>
              ) : (
                <>
                  <div className="h-full" style={{ overflowY: "auto" }}>
                    <div className="p-[2rem]" style={{ position: "relative" }}>
                      <div className="flex justify-center mb-12 mt-12">
                        <img src={plnSymbol} className="w-[5rem] h-[5rem]" />
                      </div>
                      <h1 className="font-[500] text-3xl text-gray-900 text-center">
                        Thank you for taking the time!
                      </h1>
                      <p className="text-gray-900 mt-4 text-center text-lg">
                        Unfortunately, we are not accepting additional responses
                        at this time. Check back later for more opportunities to
                        share your story!
                      </p>

                      <div className="mt-5 mb-6">
                        <button
                          className="bg-orange-500 flex gap-x-2 items-center justify-center text-white w-full py-[0.75rem] shadow-lg border-[1px] border-orange-600 font-bold rounded-lg"
                          onClick={() => {
                            if (Capacitor.isNativePlatform()) {
                              history.push("/manage");

                              return;
                            }

                            window.open(
                              "https://projectleannation.com",
                              "_self",
                            );
                          }}
                        >
                          <span>Return Home</span>
                          <span
                            style={{
                              lineHeight: 1,
                              position: "relative",
                              top: 2,
                            }}
                          >
                            <IonIcon
                              style={{ fontSize: 20 }}
                              icon={arrowForward}
                            />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialPage;
